<nav aria-label="breadcrumb" class="">
  <ol class="breadcrumb mb-0">
    <li 
      v-for="(crumb, index) in breadcrumbs" 
      :key="crumb.path" 
      class="breadcrumb-item mb-1"
      :class="{ active: index === breadcrumbs.length - 1 }"
    >
      <router-link 
        v-if="index !== breadcrumbs.length - 1" 
        :to="crumb.path" 
        class="text-dark text-decoration-none fw-semibold text-xxs"
      >
        {{ crumb.label }}
      </router-link>
      
      <span v-else class="text-dark text-xxs fw-bold" aria-current="page">
        {{ crumb.label }}
      </span>
    </li>
  </ol>
</nav>